import defaultSettings from 'src/settings'
import i18n from 'src/lang'

const title = defaultSettings.title || '郑州波特乐电气有限公司'

export default function getPageTitle(key) {
    const hasKey = i18n.te(`route.${key}`)
    if (hasKey) {
        const pageName = i18n.t(`route.${key}`)
        return `${pageName} - ${title}`
    }
    return `${title}`
}
